export default {
    retrieve: "comment/retrieve",
    recent: "comment/recent",
    post: "comment/post"
};